import React from "react";

export default function Settings() {
  return (
    <div className="space-y-4">
      <section className="liti-card p-6 shadow-sm border border-[#ECE7FA] space-y-4">
        <h1 className="text-2xl font-bold text-[#24152F] font-serif tracking-tight">
          Configurações
        </h1>

        <p className="text-xs text-[#6D6680] font-medium leading-relaxed">
          Esta área reúne preferências de conta, notificações e opções gerais do seu MariaM.
        </p>

        <div className="rounded-2xl border border-dashed border-[#ECE7FA] bg-[#FAFAFC] p-4 text-center">
          <p className="text-xs font-bold text-[#6C54D8]">
            ✨ Suas configurações estão atualizadas e otimizadas para este dispositivo.
          </p>
        </div>
      </section>
    </div>
  );
}